var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	5036: () => (loadSingletonVersion("default", "react", true, [4,19,2,7], () => (() => (__webpack_require__(82483))))),
	79643: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [4,2,12,0], () => (Promise.all([__webpack_require__.e(6205), __webpack_require__.e(5117), __webpack_require__.e(9649)]).then(() => (() => (__webpack_require__(99649))))))),
	19460: () => (loadSingletonVersion("default", "react-redux", false, [4,9,3,0], () => (__webpack_require__.e(1965).then(() => (() => (__webpack_require__(91965))))))),
	23328: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-constants", false, [4,0,1,86], () => (__webpack_require__.e(4860).then(() => (() => (__webpack_require__(4860))))))),
	37774: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,11,11], () => (Promise.all([__webpack_require__.e(7451), __webpack_require__.e(5181), __webpack_require__.e(9643), __webpack_require__.e(9460), __webpack_require__.e(3328), __webpack_require__.e(3472), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(75181))))))),
	53472: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-web-trading", false, [4,2,0,58], () => (__webpack_require__.e(2462).then(() => (() => (__webpack_require__(2462))))))),
	86855: () => (loadSingletonVersion("default", "dayjs", false, [4,1,11,21], () => (__webpack_require__.e(4686).then(() => (() => (__webpack_require__(54686))))))),
	92684: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-market-data-ws", false, [4,1,0,11], () => (__webpack_require__.e(694).then(() => (() => (__webpack_require__(40694))))))),
	33945: () => (loadSingletonVersion("default", "js-cookie", false, [1,3,0,8], () => (__webpack_require__.e(38).then(() => (() => (__webpack_require__(38))))))),
	89039: () => (loadSingletonVersion("default", "react-dom", false, [4,19,2,7], () => (__webpack_require__.e(7617).then(() => (() => (__webpack_require__(99998))))))),
	65093: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-instruments", false, [4,1,2,47], () => (Promise.all([__webpack_require__.e(8745), __webpack_require__.e(3328), __webpack_require__.e(3472), __webpack_require__.e(6855)]).then(() => (() => (__webpack_require__(28745))))))),
	82849: () => (loadSingletonVersion("default", "styled-components", false, [4,6,4,3], () => (Promise.all([__webpack_require__.e(8586), __webpack_require__.e(4406)]).then(() => (() => (__webpack_require__(48586))))))),
	22853: () => (loadSingletonVersion("default", "i18next", false, [4,26,3,6], () => (__webpack_require__.e(5032).then(() => (() => (__webpack_require__(95032))))))),
	4197: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-marketdata", false, [4,1,1,42], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(5715), __webpack_require__.e(3328), __webpack_require__.e(3472), __webpack_require__.e(2684)]).then(() => (() => (__webpack_require__(5715))))))),
	18002: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-frontend-hooks", false, [4,1,0,31], () => (__webpack_require__.e(8484).then(() => (() => (__webpack_require__(68484))))))),
	3289: () => (loadSingletonVersion("default", "react-device-detect", false, [4,2,2,3], () => (__webpack_require__.e(8850).then(() => (() => (__webpack_require__(78850))))))),
	7502: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-accounts", false, [4,2,1,39], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(70227))))))),
	7681: () => (loadSingletonVersion("default", "react-router", false, [4,8,2,0], () => (__webpack_require__.e(8108).then(() => (() => (__webpack_require__(68108))))))),
	19168: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-charts", false, [4,1,6,40], () => (__webpack_require__.e(9728).then(() => (() => (__webpack_require__(99728))))))),
	20635: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-client", false, [4,1,9,60], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(5746), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(15746))))))),
	22746: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-orders", false, [4,1,0,13], () => (Promise.all([__webpack_require__.e(1587), __webpack_require__.e(2092)]).then(() => (() => (__webpack_require__(82092))))))),
	23592: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-subscriptions", false, [4,0,1,0], () => (Promise.all([__webpack_require__.e(5078), __webpack_require__.e(9610)]).then(() => (() => (__webpack_require__(67229))))))),
	50188: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-messages", false, [4,1,0,17], () => (__webpack_require__.e(727).then(() => (() => (__webpack_require__(70727))))))),
	51148: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-watchlists", false, [4,1,3,49], () => (__webpack_require__.e(7195).then(() => (() => (__webpack_require__(27195))))))),
	51171: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-design-system", false, [4,0,88,26], () => (Promise.all([__webpack_require__.e(6205), __webpack_require__.e(9888), __webpack_require__.e(3501), __webpack_require__.e(4406), __webpack_require__.e(1041), __webpack_require__.e(1861)]).then(() => (() => (__webpack_require__(23501))))))),
	56419: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-module", false, [4,1,2,16], () => (__webpack_require__.e(1052).then(() => (() => (__webpack_require__(38671))))))),
	64675: () => (loadSingletonVersion("default", "@cmctechnology/semantic-conventions", false, [1,1,2,1], () => (__webpack_require__.e(6669).then(() => (() => (__webpack_require__(36669))))))),
	71475: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-analytics", false, [4,2,1,34], () => (Promise.all([__webpack_require__.e(3755), __webpack_require__.e(3230)]).then(() => (() => (__webpack_require__(33755))))))),
	76241: () => (loadSingletonVersion("default", "react-i18next", false, [4,17,0,10], () => (__webpack_require__.e(7756).then(() => (() => (__webpack_require__(97756))))))),
	82932: () => (loadSingletonVersion("default", "usehooks-ts", false, [4,3,1,1], () => (__webpack_require__.e(2506).then(() => (() => (__webpack_require__(10125))))))),
	83067: () => (loadSingletonVersion("default", "i18next-xhr-backend", false, [4,3,2,2], () => (__webpack_require__.e(7468).then(() => (() => (__webpack_require__(75087))))))),
	85484: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-exchange", false, [4,1,7,9], () => (Promise.all([__webpack_require__.e(6217), __webpack_require__.e(2820), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(72820))))))),
	89866: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-account-management", false, [4,0,2,7], () => (Promise.all([__webpack_require__.e(4204), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(74204))))))),
	96538: () => (loadSingletonVersion("default", "@grafana/faro-web-tracing", false, [1,2,8,2], () => (__webpack_require__.e(5810).then(() => (() => (__webpack_require__(5810))))))),
	96810: () => (loadSingletonVersion("default", "@grafana/faro-react", false, [1,2,8,2], () => (__webpack_require__.e(9459).then(() => (() => (__webpack_require__(69459))))))),
	83230: () => (loadSingletonVersion("default", "react-router", false, [4,8,2,0], () => (__webpack_require__.e(4450).then(() => (() => (__webpack_require__(84450))))))),
	64406: () => (loadSingletonVersion("default", "stylis", false, [4,4,4,0], () => (__webpack_require__.e(9049).then(() => (() => (__webpack_require__(9049))))))),
	57282: () => (loadSingletonVersion("default", "react-select", false, [4,5,10,2], () => (__webpack_require__.e(102).then(() => (() => (__webpack_require__(30102))))))),
	96748: () => (loadSingletonVersion("default", "lodash.merge", false, [4,4,6,2], () => (__webpack_require__.e(4147).then(() => (() => (__webpack_require__(24147))))))),
	43707: () => (loadSingletonVersion("default", "@forgerock/javascript-sdk", false, [4,4,9,1], () => (Promise.all([__webpack_require__.e(6205), __webpack_require__.e(5117), __webpack_require__.e(6011)]).then(() => (() => (__webpack_require__(76011))))))),
	15078: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,11,11], () => (Promise.all([__webpack_require__.e(6217), __webpack_require__.e(7451), __webpack_require__.e(4687), __webpack_require__.e(3328), __webpack_require__.e(3472), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(64687)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"1041": [
		57282,
		96748
	],
	"2684": [
		92684
	],
	"2849": [
		82849
	],
	"2853": [
		22853
	],
	"3150": [
		3289,
		7502,
		7681,
		19168,
		20635,
		22746,
		23592,
		50188,
		51148,
		51171,
		56419,
		64675,
		71475,
		76241,
		82932,
		83067,
		85484,
		89866,
		96538,
		96810
	],
	"3230": [
		83230
	],
	"3328": [
		23328
	],
	"3472": [
		53472
	],
	"3707": [
		43707
	],
	"3945": [
		33945
	],
	"4197": [
		4197
	],
	"4406": [
		64406
	],
	"5036": [
		5036
	],
	"5078": [
		15078
	],
	"5093": [
		65093
	],
	"6855": [
		86855
	],
	"7774": [
		37774
	],
	"8002": [
		18002
	],
	"9039": [
		89039
	],
	"9460": [
		19460
	],
	"9643": [
		79643
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}